<section
  [style.margin-top]="config?.offset"
  [ngClass]="{ 'slide-out__full': config?.isFull }"
  class="modal custom--modal plan-review__panel modal--panel"
  @slideRight
>
  <header data-test-id="slideOutHeader">
    <ng-content select="[header]"></ng-content>
  </header>

  <main data-test-id="slideOutMainContent">
    <ng-content select="[body]"></ng-content>
  </main>

  <footer data-test-id="slideOutFooter">
    <ng-content select="[footer]"></ng-content>
  </footer>
</section>
